<script>
import { mapState } from 'vuex'
// eslint-disable-next-line import/no-relative-parent-imports
import LadFilterButtons from '../ranges/buttons'

export default {
  name: 'LadFilterCommon',
  components: { LadFilterButtons },
  data() {
    return {
      value: [],
      filter: [],
      visible: false,
      hasDefaultLabel: true,
      type: '',
      filterType: null,
    }
  },
  computed: {
    ...mapState('search', {
      searchValues: 'values',
      searchForm: 'form',
    }),
    firstFilter() {
      return this.value[0]
    },
    lastFilter() {
      return this.filter[this.filter.length - 1]
    },
  },
  methods: {
    _resetLabel() {
      this.hasDefaultLabel = true
      this.type = ''
    },
    _enableLabel() {
      this.visible = false
      this.hasDefaultLabel = false
      this.type = 'success'
    },
    async _setForm() {
      const data = { filters: {} }
      data.filters[this.filterType] = this.filter

      await this.$store.dispatch('search/setForm', data)
    },
    handleApply() {
      this.filter =
        this.value.length === 2 &&
        (this.value[0] !== this.min || this.value[1] !== this.max)
          ? this.value
          : []
      this._setForm()

      if (this.filter.length) {
        this._enableLabel()
      } else {
        this._resetLabel()
        this.visible = false
      }
      this.$emit('change')
    },
    handleClear() {
      this.value = [this.min, this.max]
      this.filter = []
      this._setForm()

      this._resetLabel()
      this.$emit('change')
    },
  },
}
</script>
